import { initNotificationsRegistry } from 'masonry-registries/notifications.registry';

initNotificationsRegistry();
